import React, { FC, useContext } from 'react';

import { EvCheckbox } from '@evinced-private/ui-common';

import { JobTypeDto } from '../../interfaces/ScheduledJobConfiguration';

import { SchedulingSectionContext } from './context';
import { schedulingLabels } from './labels';

export const CrawlBeforeScanBlock: FC = () => {
	const { config, updateConfig } = useContext(SchedulingSectionContext);

	const onCrawlBeforeScanChange = (): void => {
		updateConfig({
			jobType:
				config.jobType === JobTypeDto.CRAWL_AND_SCAN ? JobTypeDto.SCAN : JobTypeDto.CRAWL_AND_SCAN
		});
	};

	return (
		<EvCheckbox
			id="scheduling-crawl-before-scan-checkbox"
			label={schedulingLabels.crawlBeforeScan}
			ariaLabel={schedulingLabels.crawlBeforeScan}
			isChecked={
				config.jobType === JobTypeDto.CRAWL_AND_SCAN || config.jobType === JobTypeDto.CRAWL
			}
			onClick={onCrawlBeforeScanChange}
		/>
	);
};
